import { useEffect } from 'react';

type GoogleTagManagerProps = {
    gtmId: string;
}
const GoogleTagManager: React.FC<GoogleTagManagerProps> = ({gtmId}: GoogleTagManagerProps) => {

    useEffect(() => {
        if (gtmId == '') return;
        (function(w: Record<string, any>, d: Document, l: string, i: string) {
            w[l] = w[l] || [];
            w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
            const f = d.getElementsByTagName("script")[0];
            const j = d.createElement("script");
            const dl = l !== 'dataLayer' ? '&l=' + l : '';
            j.async = true;
            j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode?.insertBefore(j, f);
        })(window, document, 'dataLayer', gtmId);
    }, [gtmId]);

    return null;
}

export default GoogleTagManager;